import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  AdminFormFieldCheckbox,
  AdminFormFieldDropdown,
  AdminFormFieldInput,
} from "../../../../components/admin/formFields";
import { MEDIA_OPTIONS } from "../../constants";

interface RollingStopProps {
  values: any;
  errors: any;
  touched: any;
  handleChange: (event: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any) => void;
  handleBlur: (event: React.FocusEvent<any>) => void;
  setFieldTouched: (field: string, isTouched: boolean) => void;
  selectedField: string;
}

const RollingStop: FC<RollingStopProps> = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  handleBlur,
  setFieldTouched,
  selectedField,
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management.traffic_signal_detection",
  });
  const { t: tMain } = useTranslation("translation", {
    keyPrefix: "camera.dashboard.management",
  });

  const eventKey = selectedField?.replace(/Enable$/, "");

  const videoBeforeField = `${eventKey}_videoBefore`;
  const videoAfterField = `${eventKey}_videoAfter`;
  const audioPreWarning = `${eventKey}_audioPreWarning`;
  const audioAlertField = `${eventKey}_audioAlert`;
  const mediaField = `${eventKey}_media`;
  return (
    <>
      <div className="col-span-6 p-6 border-b space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h1 className="text-lg text-accent-blue-dark font-bold mb-4">
            {t("rollingStopEnable")}
          </h1>
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("event_recording")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("event_recording_description")}
          </p>
        </div>
        <div className="col-span-6 grid grid-cols-12 gap-6">
          <AdminFormFieldInput
            type="number"
            label={t("pre_event_video_duration_sec")}
            name={videoBeforeField}
            id={videoBeforeField}
            value={values[videoBeforeField]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors[videoBeforeField]}
            touched={touched[videoBeforeField]}
            customWrapperClass="col-span-6"
          />
          <AdminFormFieldInput
            type="number"
            label={t("post_event_video_duration_sec")}
            name={videoAfterField}
            id={videoAfterField}
            value={values[videoAfterField]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors[videoAfterField]}
            touched={touched[videoAfterField]}
            customWrapperClass="col-span-6"
          />
        </div>
      </div>
      <div className="col-span-6 p-6 space-y-1 border-b">
        <h2 className="block font-semibold text-sm leading-none tracking-normal mb-4">
          {tMain("auto_upload")}
        </h2>
        <p className="font-normal text-sm leading-none mb-8 text-gray-500">
          {tMain("choose_upload_data")}
        </p>
        <AdminFormFieldDropdown
          label={tMain("media")}
          id={mediaField}
          key={mediaField}
          name={mediaField}
          value={values[mediaField] ?? "snapshot"}
          options={MEDIA_OPTIONS}
          onChange={(e) => {
            setFieldValue(mediaField, e?.value);
          }}
          onBlur={(e) => {
            setFieldTouched(mediaField, true);
            handleBlur(e);
          }}
          error={errors[mediaField]}
          touched={touched[mediaField]}
          customWrapperClass="col-span-3 mt-6"
        />
      </div>
      <div className="col-span-6 p-6 space-y-1">
        <div className="w-full space-y-2 mb-4">
          <h2 className="block font-semibold text-sm leading-none tracking-normal">
            {t("in_cabin_audio_alert")}
          </h2>
          <p className="font-normal text-sm leading-none mb-4 text-gray-500">
            {t("in_cabin_audio_alert_description")}
          </p>
        </div>
        <div className="col-span-6 grid grid-cols-6 space-x-2">
          <AdminFormFieldCheckbox
            customWrapperClass="col-span-3"
            label={t("approaching_the_traffic_and_signal")}
            id={audioPreWarning}
            type="checkbox"
            name={audioPreWarning}
            checked={values[audioPreWarning]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors[audioPreWarning]}
            touched={touched[audioPreWarning]}
          />
          <AdminFormFieldCheckbox
            customWrapperClass="col-span-3"
            label={t("violate_the_traffic_sign_or_signal")}
            id={audioAlertField}
            type="checkbox"
            name={audioAlertField}
            checked={values[audioAlertField]}
            onChange={handleChange}
            onBlur={handleBlur}
            error={errors[audioAlertField]}
            touched={touched[audioAlertField]}
          />
        </div>
      </div>
    </>
  );
};

export default RollingStop;
